/**
 * Enumeration for the origin types of track data.
 *
 * @readonly
 * @enum {string}
 */
export const OriginTypes = {
    GPRS: 'TRC',
    SATELLITE: 'STR'
}

Object.freeze(OriginTypes)
